function SendGTAGEvent(event_name: string, category: string, action: string, label?: string | object) {
  gtag("event", `${event_name}`, {
    category: `${category}`,
    action: `${action}`,
    label:  `${label}`,
  });
}


export default SendGTAGEvent;


